import { render, staticRenderFns } from "./MailSendField.vue?vue&type=template&id=37784c3e&scoped=true"
import script from "./MailSendField.ts?vue&type=script&lang=ts&external"
export * from "./MailSendField.ts?vue&type=script&lang=ts&external"
import style0 from "./MailSendField.vue?vue&type=style&index=0&id=37784c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37784c3e",
  null
  
)

export default component.exports